import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../core/app.service';
import { SearchService } from '../core/search.service';
import { MX_API_URL, STATE_TYPE_ID } from '../core/app.constant';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { InsuranceTypeLookupValue } from '../api/model/insurance/insurance-type.model';
import { ScopeCapabilityTypeLookupValue } from '../api/model/scope-capability/scope-capability-type.model';
import { CertificateTypeLookupValue } from '../api/model/compliance/certificate-type.model';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css']
})
export class ResultComponent implements OnInit {

  @ViewChild('fromPlacesRef') fromPlacesRef: GooglePlaceDirective;
  @ViewChild('toPlacesRef') toPlacesRef: GooglePlaceDirective;
  @ViewChild('fromInput') fromInput: ElementRef;
  @ViewChild('toInput') toInput: ElementRef;

  results: any = [];
  baseResults: any = [];
  localResult: any = [];
  longResult: any = [];
  internationalResult: any = [];
  validatedResult: any = [];
  iamResult: any = [];
  nonIamResult: any = [];
  trustedResult: any = [];
  todayDate = new Date();
  currYear = this.todayDate.getFullYear();
  page = 1;
  pageSize = 10;
  predicate!: string;
  ascending!: boolean;
  currentSort = 'az';
  searchQuery?: any;
  searchQueryLink = null;
  adv: any;
  searchTerm = '';
  isLoading = true;
  isSwitchingSearchMode = false;
  scopeFilter: any = [];

  showCompanySearch = false;
  companyName = '';
  selectedServiceType = 'All Service Types';
  showServiceDropdown = false;

  fromLocation?: any = '';
  fromLatitude?: any = '';
  fromLongitude?: any = '';
  fromCountry?: any = '';

  toLocation?: any = '';
  toLatitude?: any = '';
  toLongitude?: any = '';
  toCountry?: any = '';
  range?: any = 50;
  // TODO: Find out whether spc should be set to '10,11' by default
  spc?: any = '10,11';
  // spc?: any = '';
  svc?: any = '';
  options = {
    fields: ['name', 'geometry.location', 'address_components', 'formatted_address']
  };

  selectedServices: { id: string, label: string }[] = [];

  constructor(private service: AppService, private searchService: SearchService, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      console.log('Loading results with params: ' + JSON.stringify(params));
      this.loadResults(params);
    });
  }

  loadResults(params: any): void {
    this.isSwitchingSearchMode = false;
    this.page = 1;
    this.fromLocation = params.fromLocation || '';
    this.fromLatitude = params.fromLatitude || '';
    this.fromLongitude = params.fromLongitude || '';
    this.fromCountry = params.fromCountry || '';

    this.toLocation = params.toLocation || '';
    this.toLatitude = params.toLatitude || '';
    this.toLongitude = params.toLongitude || '';
    this.toCountry = params.toCountry || '';

    this.range = params.range || 50;
    // TODO: Find out whether spc should be set to '10,11' by default
    this.spc = params.spc || '10,11';
    this.svc = params.svc || '';
    this.companyName = params.companyName || '';
    if (params.sort === 'geodistance,asc') {
      this.currentSort = 'nearest';
    } else if (params.sort === 'established,desc') {
      this.currentSort = 'years';
    } else if (this.companyName) {
      this.currentSort = 'az';
    } else if (this.fromLocation || this.toLocation) {
      this.currentSort = 'nearest';
    } else {
      this.currentSort = 'az';
    }

    if (this.companyName) {
      this.showCompanySearch = true;
      this.searchTerm = this.companyName;
    } else {
      this.searchTerm = this.fromLocation;
    }
    if (!this.companyName && this.svc && !['5950', '5951', '5952'].includes(this.svc.split(',')[0])) {
       this.companyName = this.svc;
    }

    this.selectedServices = [];
    if (this.svc) {
      const svcIds = this.svc.split(',');
      svcIds.forEach(id => {
        if (id === '5950') this.selectedServices.push({ id: '5950', label: 'Local' });
        else if (id === '5951') this.selectedServices.push({ id: '5951', label: 'Long Distance' });
        else if (id === '5952') this.selectedServices.push({ id: '5952', label: 'International' });
      });
      this.updateServiceTypeLabel();
    } else if (this.fromLocation || this.toLocation) {
      this.service.searchScope(params).subscribe(response => {
        const scope = response.body;
        if (scope === 'LOCAL') {
          this.selectedServices = [{ id: '5950', label: 'Local' }];
        } else if (scope === 'LONG_DISTANCE') {
          this.selectedServices = [{ id: '5951', label: 'Long Distance' }];
        } else if (scope === 'INTERNATIONAL') {
          this.selectedServices = [{ id: '5952', label: 'International' }];
        }
        this.svc = this.selectedServices.map(s => s.id).join(',');
        this.updateServiceTypeLabel();
        this.filterResult();
      });
    }

    if (this.selectedServices.length === 0) {
      this.selectedServiceType = 'All Service Types';
    }

    this.isLoading = true;
    console.log('Loading service providers with params: ' + JSON.stringify(params));
    this.searchService.searchServiceProviders(params).subscribe((response) => {
      this.baseResults = response.body || [];
      if (this.baseResults.length === 0) {
        this.results = [];
        this.adv = null;
      }
      /*
      if (params.companyName) {
        this.baseResults = response.body.map(function (item) {
          return item['searchResult'] || item;
        });
      } else {
        this.baseResults = response.body;
      }
       */
      this.filterResult();
      this.sortResults();
      if (this.results && this.results.length > 0) {
        this.searchService.getAdvertisments(params).subscribe((r) => {
          this.adv = r.body.serviceprovider;
          this.adv.resultTagline = r.body.resultTagline;
          if (this.adv) {
            this.isIamMember(this.adv);
            this.removeAdv(this.adv, this.results);
            this.removeAdv(this.adv, this.baseResults);
          }
        });
      }

      this.isLoading = false;
    });

    if (params.loc && params.svc) {
      this.searchQuery = params.loc + ' & ' + params.svc;
    } else if (params.loc) {
      this.searchQuery = params.loc + ' Licensing & Compliance';
      this.getSearchQueryLink(params.loc);
    } else if (params.svc) {
      this.searchQuery = params.svc;
    }
  }

  mxEmail(emailid: any): void {
    console.log('mxEmail...' + emailid);
    this.sendMail(emailid, 'Query from IAMTrusted.org', '');
  }

  sendMail(emailId: any, subject: any, message: any): void {
    window.open('mailto:' + emailId + '?subject=' + subject + '&body=' + message, '_self');
  }

  getApprovalStatusIndicator(mxstatus: any, appFlag: any, expiryDate: any, reviewDate: any): any {
    if (this.isSupportedMxStatus(mxstatus)) {

      if (expiryDate == null && reviewDate == null && appFlag === true) {
        return 'color:green';
      }

      if (expiryDate != null) {
        const expDate = new Date(expiryDate);
        if (appFlag === true && expDate > this.todayDate) {
          return 'color:green';
        }
      }

      if (reviewDate != null) {
        const revDate = new Date(reviewDate);
        if (appFlag === true && revDate > this.todayDate) {
          return 'color:green';
        }
      }

      return 'color:orange';
    }
  }

  getApprovalStatusIndicatorByCertificateType(mxstatus: any, compliances: any, certificateTypeLookupValue: string): any {

    if (this.isSupportedMxStatus(mxstatus)) {
      const compliance = this.findCompliance(compliances, certificateTypeLookupValue);
      if (!compliance) {
        return 'color:orange';
      }

      return this.getApprovalStatusIndicator(mxstatus, compliance.valApproved, compliance.expirydate, compliance.reviewdate);
    }
  }

  getApprovalStatusIndicatorMemberships(mxstatus: any, appFlag: any, expiryDate: any, reviewDate: any, memberAssoc: any): any {

    if (this.isSupportedMxStatus(mxstatus)) {
      if (expiryDate == null && reviewDate == null && appFlag === true) {
        return 'color:green';
      }

      if (expiryDate != null) {
        const eDate = new Date(expiryDate);
        if (appFlag === true && eDate > this.todayDate) {
          return 'color:green';
        } else {
          return 'color:orange';
        }
      }

      if (reviewDate != null) {
        const revDate = new Date(reviewDate);
        if (appFlag === true && revDate > this.todayDate) {
          return 'color:green';
        }
      }

      if (memberAssoc?.memberType && memberAssoc?.memberStatus) {
        if (memberAssoc.memberType.flex2 === 'Y') {
          if (memberAssoc.memberStatus.id === 1201) {
            return 'color:green';
          } else {
            return 'color:orange';
          }
        }
      }

      // console.log('2 :
      // '+JSON.stringify(memberAssoc.memberStatus.id));
      if (!memberAssoc) {
        return '';
      }

      return 'color:orange';
    }

    if (memberAssoc?.memberAssociation?.id === 800) {
      if (expiryDate != null) {
        const expDate = new Date(expiryDate);
        if (appFlag === true && expDate > this.todayDate) {
          return 'color:green';
        } else {
          return 'color:orange';
        }
      }
    }
  }

  skypeAndWhatsappUrl(contact: any, type: any, isSkype: any) {

    if (contact.skypeId != null || contact.whatsapp != null) {
      if (this.isProviderAvailable(contact)) {
        if (isSkype) {
          window.open('skype:' + contact.skypeId + '?' + type);
        } else {
          window.open('https://api.whatsapp.com/send?phone=' + contact.whatsapp);
        }

      } else {
        if (contact.timezone) {
          const localTime = this.service.getLocalDateTime(contact.timezone.flex1);
          let days = '';
          if (contact.skypeMon) { days = days + 'Mon&nbsp;'; }
          if (contact.skypeTue) { days = days + 'Tue&nbsp;'; }
          if (contact.skypeWed) { days = days + 'Wed&nbsp;'; }
          if (contact.skypeThr) { days = days + 'Thr&nbsp;'; }
          if (contact.skypeFri) { days = days + 'Fri&nbsp;'; }
          if (contact.skypeSat) { days = days + 'Sat&nbsp;'; }
          if (contact.skypeSun) { days = days + 'Sun&nbsp;'; }
          const body = '<fieldset class="scheduler-border"><legend class="scheduler-border">Normal Business Hours</legend>'
            + '<table><tr>'
            + '<td><span style="height: 25px;"> Local time:&nbsp;</span></td>'
            + '<td><a style="pointer-events: none;">' + localTime + '</a></td>'
            + '</tr>'
            + '<tr>'
            + '<td><span style="height: 25px;"> Available days:&nbsp;</span></td>'
            + '<td><a style="pointer-events: none;">' + days + '</a></td>'
            + '</tr>'
            + '<tr>'
            + '<td><span style="height: 25px;"> Office hours:&nbsp; </span></td>'
            + '<td><a style="pointer-events: none;">' + contact.skypeTimeFrom + ' - ' + contact.skypeTimeTo + ' hrs</a></td>'
            + '</tr></table></fieldset>';
          alert(body);
        }
        alert('Currently Not Available!');
      }
    }
  }

  isProviderAvailable(address: any): any {

    if (!address.timezone || (!address.skypeTimeFrom && !address.skypeTimeTo)) {
      return true;
    }

    if (address.timezone) {
      const date = this.service.getLocalDateTime(address.timezone.flex1);
      const nd = this.service.getUTCDate(address.timezone.flex1);

      const dateTo = nd.getFullYear() + '/' + (nd.getMonth() + 1) + '/' + nd.getDate() + ' ' + address.skypeTimeTo + ':' + nd.getSeconds();
      // tslint:disable-next-line:max-line-length
      const dateFrom = nd.getFullYear() + '/' + (nd.getMonth() + 1) + '/' + nd.getDate() + ' ' + address.skypeTimeFrom + ':' + nd.getSeconds();
      // console.log(" 1421. date = " + date + " dateTo = " + dateTo + " dateFrom = " + dateFrom);
      if (Date.parse(date) >= Date.parse(dateFrom) && Date.parse(date) <= Date.parse(dateTo)) {
        const day = nd.getDay();
        // console.log("1424. day = " + day);
        switch (day) {
          case 1:
            if (address.skypeMon) { return true; }
            break;
          case 2:
            if (address.skypeTue) { return true; }
            break;
          case 3:
            if (address.skypeWed) { return true; }
            break;
          case 4:
            if (address.skypeThr) { return true; }
            break;
          case 5:
            if (address.skypeFri) { return true; }
            break;
          case 6:
            if (address.skypeSat) { return true; }
            break;
          case 0:
            if (address.skypeSun) { return true; }
            break;
        }
      }
    }
    return false;
  }

  transition(): void {
    /*
    this.router.navigate(['./'], {
      relativeTo: this.activatedRoute.parent,
      queryParams: {
        page: this.page,
        sort: this.predicate + ',' + (this.ascending ? 'asc' : 'desc'),
      },
    });
    */
  }

  handleFilter($event) {
    if ($event.target.checked === true) {
      this.scopeFilter.push($event.target.value);
    } else {
      this.scopeFilter.pop($event.target.value);
    }
    this.filterResult();
    console.log(' 281 = ' + this.scopeFilter);
  }

  filterResult(): void {
    // Trusted Validated IAM-Member Non-Member
    let filteredResults = [...this.baseResults];

    // Filter by Service Types (Selected Services) - MUST support ALL selected types
    if (this.selectedServices.length > 0) {
      filteredResults = filteredResults.filter(sp => {
        if (!sp.scopeCapabilities) return false;
        return this.selectedServices.every(service =>
          sp.scopeCapabilities.some(sc => sc.capabilityType && sc.capabilityType.id.toString() === service.id)
        );
      });
    }

    this.trustedResult = filteredResults.filter(sp => (sp.trustedMoverDisplayControl !== null || sp.mxstatus.lookupcode === '5'));
    this.localResult = [];
    this.longResult = [];
    this.internationalResult = [];
    this.iamResult = [];
    this.nonIamResult = [];

    this.trustedResult.forEach(sp => {
      if (sp.scopeCapabilities) {
        // local
        const local = sp.scopeCapabilities.filter(s => s.capabilityType.id === 5950);
        if (local && local.length > 0) {
          this.localResult.push(sp);
        }

        // long distance
        const long = sp.scopeCapabilities.filter(s => s.capabilityType.id === 5951);
        if (long && long.length > 0) {
          this.longResult.push(sp);
        }
        // international
        const international = sp.scopeCapabilities.filter(s => s.capabilityType.id === 5952);
        if (international && international.length > 0) {
          this.internationalResult.push(sp);
        }
      }

      if (sp.memberAssociations) {
        const iam = sp.memberAssociations.filter(s => s.memberAssociation.id === 800);
        if (iam && iam.length > 0) {
          this.isIamMember(sp);
          this.iamResult.push(sp);
        } else {
          this.nonIamResult.push(sp);
        }
      }
    });

    this.scopeFilter = this.scopeFilter.sort();
    if (this.scopeFilter.length > 0) {
      this.results = [];
      this.scopeFilter.forEach(id => {
        if (id === '1') {
          this.results = this.results.concat(this.trustedResult.filter((item) => this.results.indexOf(item) < 0));
        } else if (id === '4') {
          this.results = this.results.concat(this.baseResults.filter((item) => this.results.indexOf(item) < 0 && item.mxstatus && item.mxstatus.lookupcode === '4'));
        } else if (id === '800') {
          this.results = this.results.concat(this.iamResult.filter((item) => this.results.indexOf(item) < 0));
        } else if (id === '5950') {
          this.results = this.results.concat(this.localResult.filter((item) => this.results.indexOf(item) < 0));
        } else if (id === '5951') {
          this.results = this.results.concat(this.longResult.filter((item) => this.results.indexOf(item) < 0));
        } else if (id === '5952') {
          this.results = this.results.concat(this.internationalResult.filter((item) => this.results.indexOf(item) < 0));
        } else if (id === '6000') {
          this.results = this.results.concat(this.nonIamResult.filter((item) => this.results.indexOf(item) < 0));
        }
      });
    } else {
      this.results = this.trustedResult;
    }
  }

  removeAdv(adv: any, result: any): void {
    const index = result.indexOf(adv, 0);
    if (index > -1) {
      result.splice(index, 1);
    }
  }

  getComplianceLicensesLink(sp: any, type: any, lookup: any): void {

    if (lookup.certificateType.lookupvalue === 'DOT') {
      window.open('https://safer.fmcsa.dot.gov/query.asp?searchtype=ANY&query_type=queryCarrierSnapshot&query_param=USDOT&original_query_param=NAME&query_string=' + lookup.certificatenumber, '_blank');
    } else if (lookup.certificateType.lookupvalue === 'FMC') {
      this.downloadFmcCert(lookup.certificatenumber);
    } else if (lookup.website) {
      window.open(lookup.website, '_blank');
    } else {
      if (sp && sp.serviceproviderFiles && sp.mxstatus.lookupcode === '4') {

        for (let i = 0; i < sp.serviceproviderFiles.length; i++) {
          if (sp.serviceproviderFiles[i] && sp.serviceproviderFiles[i].active === true) {

            const tkns = sp.serviceproviderFiles[i].imageName.split('_');
            const itemId = tkns[1];
            const itemType = sp.serviceproviderFiles[i].image_type;
            const path = sp.serviceproviderFiles[i].imagePath.replace('/apps', '');
            if (itemType === type && lookup.certificateType.lookupvalue === itemId) {
              window.open(MX_API_URL + path, '_blank');
            }
          }
        }
      }

      if (type === 'certificate') {
        window.open(MX_API_URL + '/customer/images/' + lookup.certificateType.lookupvalue + '_cert.png', '_blank');
      }
    }
  }

  getComplianceLicensesLinkByCertificateTypeLookupValue(sp: any, compliances: any, certificateTypeLookupValue: string): void {
    const compliance = this.findCompliance(compliances, certificateTypeLookupValue);
    if (!compliance) {
      console.log('Lookup failed, certificateTypeLookupValue: ' + certificateTypeLookupValue);
      return;
    }

    this.getComplianceLicensesLink(sp,'certificate',compliance);
  }

  getWebsitLink(sp: any, mbrAss: any): boolean {

    // tslint:disable-next-line:max-line-length
    if ((mbrAss.memberAssociation.lookupvalue === 'IAM'
      || mbrAss.memberAssociation.lookupvalue === 'MXVAL')
      && mbrAss.memberStatus && mbrAss.memberStatus.lookupcode === 'ACT') {
      this.service.downloadCert(mbrAss.memberAssociation.lookupvalue, sp.id).subscribe(res => {
        const fileURL = URL.createObjectURL(res);
        window.open(fileURL, '_blank');
        return true;
      });
    } else if (sp && sp.mxstatus.lookupcode === '4') {
      if (mbrAss.website) {
        window.open(mbrAss.website, '_blank');
        return true;
      } else if (mbrAss.memberAssociation.flex4 === 'Y' && (mbrAss.memberAssociation.lookupvalue === 'ISA' ||
        mbrAss.memberAssociation.lookupvalue === 'ILN')) {
        const type = 'Validation_Cert.pdf';
        window.open(MX_API_URL + '/customer/images/' + mbrAss.memberAssociation.lookupvalue + '_' + type, '_blank');
        return true;
      } else if (mbrAss.memberAssociation.flex2 === 'D') {
        const type = 'cert.png';
        window.open(MX_API_URL + '/customer/images/' + mbrAss.memberAssociation.lookupvalue + '_' + type, '_blank');
        return true;
      } else {
        this.getComplianceLicensesLink(sp, 'membership', mbrAss.memberAssociation);
        return true;
      }
    }
    return true;
  }
  downloadFmcCert(organization: any): void {
    this.service.getFmcCert(organization).subscribe(res => {
      const fileURL = URL.createObjectURL(res);
      window.open(fileURL, '_blank');
    });
  }

  isIamMember(sp): boolean {
    const iam = sp.memberAssociations.filter(s => s.memberAssociation.id === 800);
    if (iam && iam.length > 0) {
      sp.isIamMember = true;
      return true;
    }
    return false;
  }

  errorHandler(event) {
    event.target.src = '../assets/img/nologo.png';
  }

  getSearchQueryLink(loc: any): void {
    if (loc) {
      const splitted = loc.split(',');
      if (splitted.length > 2) {
        const code = splitted[1].trim();
        const state = code.split(' ');
        this.getComplianceLink(state[0]);
      } else if (splitted.length === 2) {
        const country = splitted[1].trim();
        if (country === 'USA') {
          const code = splitted[0].trim();
          console.log(' 447.' + code);
          this.getComplianceLink(code);
        }
      }
    }
  }

  getComplianceLink(code: any): void {
    this.service.licensingCompliance(STATE_TYPE_ID, code).subscribe(
      res => {
        const lookup = res.body;
        if (lookup.flex3 && lookup.flex3.length > 1) {
          this.searchQueryLink = lookup.flex3;
        }
      }
    );
  }

  // TODO: Add data types
  isTrustedMovePro(serviceProvider: any): boolean {
    if (!serviceProvider) {
      return false;
    }

    return serviceProvider?.memberAssociations?.some(ma => this.hasTrustedMoveProMemberAssociation(ma));
  }

  hasTrustedMoveProMemberAssociation(memberAssociation: any): boolean {
    if (!memberAssociation) {
      return false;
    }

    return memberAssociation?.memberAssociation?.id === 975;
  }

  hasAnyDisplayableCompliance(compliances: any): boolean {
    if (!compliances) {
      return false;
    }

    return compliances.some(c => this.isComplianceDisplayed(c));
  }

  findCompliance(compliances: any, certificateTypeLookupValue: string) {
    return compliances.find(c => this.isComplianceMatch(c, certificateTypeLookupValue));
  }

  hasDotCompliance(compliances: any): boolean {
    return this.hasComplianceMatch(compliances, CertificateTypeLookupValue.Dot);
  }

  hasFmcCompliance(compliances: any): boolean {
    return this.hasComplianceMatch(compliances, CertificateTypeLookupValue.Fmc);
  }

  hasIntraLicCompliance(compliances: any): boolean {
    return this.hasComplianceMatch(compliances, CertificateTypeLookupValue.IntraLic);
  }

  hasBusinessLicCompliance(compliances: any): boolean {
    return this.hasComplianceMatch(compliances, CertificateTypeLookupValue.Blic);
  }

  hasComplianceMatch(compliances: any, certificateTypeLookupValue: string): boolean {
    if (!compliances) {
      return false;
    }

    return compliances.some(c => this.isComplianceMatch(c, certificateTypeLookupValue));
  }

  getOrderedCompliances(compliances: any) {
    const ordered = [];
    Object.values(CertificateTypeLookupValue).forEach((certificateTypeLookupValue) => {
      const compliance = this.findCompliance(compliances, certificateTypeLookupValue);
      ordered.push(compliance);
    });
    return ordered;
  }

  isComplianceMatch(compliance: any, certificateTypeLookupValue: string) : boolean {
    return compliance?.certificateType?.lookupvalue === certificateTypeLookupValue;
  }

  isComplianceDisplayed(compliance: any): boolean {
    return compliance?.certificateType && (
      this.isComplianceMatch(compliance, CertificateTypeLookupValue.Dot) ||
      this.isComplianceMatch(compliance, CertificateTypeLookupValue.Fmc) ||
      this.isComplianceMatch(compliance, CertificateTypeLookupValue.IntraLic) ||
      this.isComplianceMatch(compliance, CertificateTypeLookupValue.Blic)
      );
  }

  showContactModal = false;
  selectedSP: any;
  contactMethod: 'phone' | 'text' | 'email' = 'phone';
  contactName = '';
  contactDate = '';
  contactPhone = '';
  contactEmail = '';
  contactComments = '';
  contactErrors: any = {};
  isSubmitting = false;
  submitSuccess = false;
  submitError = false;

  openContactModal(sp: any, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.selectedSP = sp;
    this.contactErrors = {};
    this.submitSuccess = false;
    this.submitError = false;
    this.loadSavedContactDetails();
    this.showContactModal = true;
  }

  loadSavedContactDetails() {
    const saved = localStorage.getItem('contactMeDetails');
    if (saved) {
      try {
        const data = JSON.parse(saved);
        if (data.name) this.contactName = data.name;
        if (data.phone) this.contactPhone = data.phone;
        if (data.email) this.contactEmail = data.email;
        if (data.date) this.contactDate = data.date;
        if (data.comments) this.contactComments = data.comments;
        if (data.method) this.contactMethod = data.method;
      } catch (e) { console.error('Error parsing saved details', e); }
    }
  }

  saveContactDetails() {
    const data = {
      name: this.contactName,
      phone: this.contactPhone,
      email: this.contactEmail,
      date: this.contactDate,
      comments: this.contactComments,
      method: this.contactMethod
    };
    localStorage.setItem('contactMeDetails', JSON.stringify(data));
  }

  closeContactModal() {
    this.showContactModal = false;
  }

  setContactMethod(method: 'phone' | 'text' | 'email') {
    this.contactMethod = method;
    this.saveContactDetails();
  }

  submitContactForm() {
    this.contactErrors = {};
    let hasError = false;

    if (!this.contactName || !this.contactName.trim()) {
      this.contactErrors.name = true;
      hasError = true;
    }
    if (this.contactMethod === 'email') {
      if (!this.contactEmail || !this.contactEmail.trim() || !this.validateEmail(this.contactEmail)) {
        this.contactErrors.email = true;
        hasError = true;
      }
    } else {
      if (!this.contactPhone || !this.contactPhone.trim()) {
        this.contactErrors.phone = true;
        hasError = true;
      }
    }

    if (hasError) {
      return;
    }

    this.isSubmitting = true;
    this.submitSuccess = false;
    this.submitError = false;

    const contactData = {
      name: this.contactName,
      fromLocation: this.fromLocation,
      toLocation: this.toLocation,
      plannedMoveDate: this.contactDate,
      contactMethod: this.contactMethod,
      phone: this.contactPhone,
      email: this.contactEmail,
      comments: this.contactComments
    };

    this.service.submitContactForm(this.selectedSP.id, contactData).subscribe(
      () => {
        this.isSubmitting = false;
        this.submitSuccess = true;
        setTimeout(() => {
          this.closeContactModal();
          this.submitSuccess = false;
        }, 10000);
      },
      (error) => {
        this.isSubmitting = false;
        this.submitError = true;
        console.error('Error submitting contact form', error);
      }
    );
  }

  validateEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  getOrderedScopeCapabilities(scopeCapabilities: any) {
    const ordered = [];
    if (!scopeCapabilities) {
      return ordered;
    }

    Object.values(ScopeCapabilityTypeLookupValue).forEach((scopeCapabilityTypeLookupValue) => {
      const scopeCapability = this.findScopeCapability(scopeCapabilities, scopeCapabilityTypeLookupValue);
      if (scopeCapability) {
        ordered.push(scopeCapability);
      }
    });
    return ordered;
  }

  findScopeCapability(scopeCapabilities: any, capabilityTypeLookupValue: string) {
    return scopeCapabilities.find(c => this.isScopeCapabilityMatch(c, capabilityTypeLookupValue));
  }

  isScopeCapabilityMatch(scopeCapability: any, capabilityTypeLookupValue: string) : boolean {
    return scopeCapability?.capabilityType?.lookupvalue === capabilityTypeLookupValue;
  }

  getOrderedInsurances(insurances: any) {
    const ordered = [];
    if (!insurances) {
      return ordered;
    }

    Object.values(InsuranceTypeLookupValue).forEach((insuranceTypeLookupValue) => {
      const insurance = this.findInsurance(insurances, insuranceTypeLookupValue);
      ordered.push(insurance);
    });
    return ordered;
  }

  findInsurance(insurances: any, insuranceTypeLookupValue: string) {
    return insurances.find(c => this.isInsuranceTypeMatch(c, insuranceTypeLookupValue));
  }

  isInsuranceTypeMatch(insurance: any, insuranceTypeLookupValue: string) : boolean {
    return insurance?.insuranceType?.lookupvalue === insuranceTypeLookupValue;
  }

  isSupportedMxStatus(mxStatusLookupValue: string) : boolean {
    return mxStatusLookupValue === '3' || mxStatusLookupValue === '4' || mxStatusLookupValue === '5';
  }

  public handleFromAddressChange(address: Address) {
    this.fromLatitude = address.geometry.location.lat();
    this.fromLongitude = address.geometry.location.lng();
    this.fromLocation = address.formatted_address;
    const filtered_array = address?.address_components?.filter(function (address_component) {
      return address_component.types.includes('country');
    });
    this.fromCountry = filtered_array?.length ? filtered_array[0].long_name : '';
  }

  public handleToAddressChange(address: Address) {
    this.toLatitude = address.geometry.location.lat();
    this.toLongitude = address.geometry.location.lng();
    this.toLocation = address.formatted_address;
    const filtered_array = address?.address_components?.filter(function (address_component) {
      return address_component.types.includes('country');
    });
    this.toCountry = filtered_array?.length ? filtered_array[0].long_name : '';
  }

  search(sort: string = 'geodistance,asc'): void {
    if (this.companyName && sort === 'geodistance,asc') {
      sort = 'companylegalname,asc';
    }
    const params = {
      fromLocation: this.fromLocation, fromLatitude: this.fromLatitude, fromLongitude: this.fromLongitude, fromCountry: this.fromCountry,
      toLocation: this.toLocation, toLatitude: this.toLatitude, toLongitude: this.toLongitude, toCountry: this.toCountry,
      range: this.range, spc: this.spc,
      svc: this.svc, companyName: this.companyName, query: 'q', size: 10, sort: sort, page: 0
    };
    this.searchService.search(params).then(navigated => {
      // If we're already on the results page and params are identical,
      // router.navigate won't trigger the queryParams observable.
      // We manually trigger loadResults to ensure a search happens.
      if (!navigated) {
        this.loadResults(params);
      }
    });
  }

  searchIamTrustedByLocation(sort: string = 'geodistance,asc'): void {
    this.router.navigate(['/search-results-location'], {
      queryParams: {
        q: this.fromLocation,
        lat: this.fromLatitude,
        lng: this.fromLongitude,
        country: this.fromCountry
      }
    });
  }

  clearAll(event?: any) {
    if (event) {
      event.stopPropagation();
    }
    this.fromLocation = '';
    this.fromLatitude = '';
    this.fromLongitude = '';
    this.fromCountry = '';
    this.toLocation = '';
    this.toLatitude = '';
    this.toLongitude = '';
    this.toCountry = '';
    this.companyName = '';
    this.svc = '';
    this.selectedServices = [];
    this.selectedServiceType = 'All Service Types';
    this.results = [];
    this.adv = null;
    this.showCompanySearch = false;
    this.scopeFilter = [];
    this.search();
  }

  clearFrom(event?: any) {
    if (event) {
      event.stopPropagation();
    }
    this.fromLocation = '';
    this.fromLatitude = '';
    this.fromLongitude = '';
    this.fromCountry = '';
    if (!this.showCompanySearch) {
      setTimeout(() => {
        if (this.fromInput) {
          this.fromInput.nativeElement.focus();
        }
      });
    }
  }

  clearTo(event?: any) {
    if (event) {
      event.stopPropagation();
    }
    this.toLocation = '';
    this.toLatitude = '';
    this.toLongitude = '';
    this.toCountry = '';
    if (!this.showCompanySearch) {
      setTimeout(() => {
        if (this.toInput) {
          this.toInput.nativeElement.focus();
        }
      });
    }
  }

  toggleCompanySearch(event?: any): void {
    if (event) {
      event.preventDefault();
    }
    if (this.results.length === 0 && !this.isLoading) {
      this.isSwitchingSearchMode = true;
    }
    this.showCompanySearch = !this.showCompanySearch;
    if (this.showCompanySearch) {
      this.clearFrom();
      this.clearTo();
      this.selectedServices = [];
      this.svc = '';
      this.updateServiceTypeLabel();
    } else {
      this.companyName = '';
      if (this.fromLocation || this.toLocation) {
        this.search();
      }
    }
  }

  filterByService(id: string, label: string): void {
    if (!id) {
      this.svc = '';
      this.selectedServices = [];
      this.selectedServiceType = 'All Service Types';
      this.showServiceDropdown = false;
    } else {
      const index = this.selectedServices.findIndex(s => s.id === id);
      if (index > -1) {
        this.selectedServices.splice(index, 1);
      } else {
        this.selectedServices.push({ id, label });
      }

      this.svc = this.selectedServices.map(s => s.id).join(',');
      this.updateServiceTypeLabel();
    }
    // this.showServiceDropdown = false; // Keep open for multi-select
    this.filterResult();
  }

  updateServiceTypeLabel(): void {
    if (this.selectedServices.length === 0) {
      this.selectedServiceType = 'All Service Types';
    } else if (this.selectedServices.length === 1) {
      this.selectedServiceType = this.selectedServices[0].label;
    } else {
      this.selectedServiceType = this.selectedServices.length + ' selected';
    }
  }

  isServiceSelected(id: string): boolean {
    return this.selectedServices.some(s => s.id === id);
  }

  removeService(id: string): void {
    const index = this.selectedServices.findIndex(s => s.id === id);
    if (index > -1) {
      this.selectedServices.splice(index, 1);
      this.svc = this.selectedServices.map(s => s.id).join(',');
      this.updateServiceTypeLabel();
      this.filterResult();
    }
  }

  setSort(option: string): void {
    this.currentSort = option;
    if (this.companyName) {
      const params: any = {
        companyName: this.companyName,
        size: this.pageSize || 10,
        page: (this.page - 1) || 0
      };
      if (option === 'az') {
        params.sort = 'companylegalname,asc';
      } else if (option === 'years') {
        params.sort = 'established,desc';
      }
      this.searchService.search(params);
    } else {
      if (option === 'nearest') {
        this.search('geodistance,asc');
      } else {
        this.sortResults();
      }
    }
  }

  sortResults(): void {
    if (this.currentSort === 'az') {
      this.results.sort((a, b) => {
        const nameA = (a.companylegalname || '').toLowerCase();
        const nameB = (b.companylegalname || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
    } else if (this.currentSort === 'years') {
      this.results.sort((a, b) => {
        const yearA = a.established || 9999;
        const yearB = b.established || 9999;
        return yearA - yearB; // Smaller year = more years in service
      });
    }
  }

  searchByCompanyName(): void {
    if (!this.companyName) {
      return;
    }
    const params = {
      companyName: this.companyName,
      size: 10, page: 0,
      sort: 'companylegalname,asc'
    };
    this.searchService.search(params);
  }
}
